import React from 'react'
import congratulation from "../Assets/Congratulations.png"
import "./success.css"

const SuccessContent = ({ eventName, edit }) => {
    return (
        <div className="d-flex justify-content-center container" style={{ alignItems: "center" }}>
            <div className="congratulations">
                <div className="text-center">
                    <img src={congratulation} className="rounded" alt="..." />
                    <h3>Congratulations!</h3>
                    {!edit && <p className="title" style={{ fontSize: "16px", fontWeight: "400" }}>
                        You have successfully registered for the
                        <br />{eventName}
                    </p>}
                    {edit && <p className="title" style={{ fontSize: "16px", fontWeight: "400" }}>
                        You registration has been edited.
                    </p>}
                </div>
            </div>
        </div>
    )
}

export default SuccessContent